import React from "react";

function StepMarker({ state }) {
  if (state === "complete") {
    return (
      <svg viewBox="0 0 16 16" width="14" height="14" fill="currentColor" aria-hidden="true">
        <path d="M6.2 11.4 3.4 8.6l-.9.9 3.7 3.7 8.5-8.5-.9-.9z" />
      </svg>
    );
  }
  if (state === "failed") {
    return (
      <svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true">
        <path
          d="M4.2 4.2l7.6 7.6M11.8 4.2l-7.6 7.6"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
    );
  }
  if (state === "current") {
    return <span className="investor-transfer-tracker__pulse" />;
  }
  if (state === "skipped") {
    return <span className="investor-transfer-tracker__dash" />;
  }
  return <span className="investor-transfer-tracker__ring" />;
}

/** Shared vertical transfer / redemption tracker UI. */
export default function TransferTrackerTimeline({ steps, ariaLabel = "Progress" }) {
  if (!steps?.length) return null;

  return (
    <div className="investor-transfer-tracker" aria-label={ariaLabel}>
      <ol className="investor-transfer-tracker__timeline">
        {steps.map((step, index) => (
          <li key={step.key} className={`investor-transfer-tracker__step is-${step.state}`}>
            <span className="investor-transfer-tracker__marker" aria-hidden="true">
              <StepMarker state={step.state} />
            </span>
            <div className="investor-transfer-tracker__content">
              <span className="investor-transfer-tracker__title">{step.title}</span>
              <span className="investor-transfer-tracker__detail">{step.detail}</span>
            </div>
            {index < steps.length - 1 ? <span className="investor-transfer-tracker__rail" aria-hidden="true" /> : null}
          </li>
        ))}
      </ol>
    </div>
  );
}
